import { useState } from "react"
import { type MarketplaceId } from "@nova-ai/shared"

import { cn } from "../../lib/utils"
import { marketplaceMeta } from "./marketplace-meta"

type MarketplaceLogoProps = {
  marketplace: MarketplaceId
  className?: string
}

export function MarketplaceLogo({ marketplace, className }: MarketplaceLogoProps) {
  const [errored, setErrored] = useState(false)
  const { brand, logoDomain, logoPath } = marketplaceMeta(marketplace)
  const src = logoPath ?? (logoDomain ? `https://icons.duckduckgo.com/ip3/${logoDomain}.ico` : null)

  if (errored || src === null) {
    return <MarketplaceLogoFallback brand={brand} className={className} />
  }

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      className={cn(
        "h-4 w-4 shrink-0 rounded-md bg-card object-contain p-0.5 ring-1 ring-border/80",
        className
      )}
      onError={() => setErrored(true)}
    />
  )
}

function MarketplaceLogoFallback({
  brand,
  className,
}: {
  brand: string
  className?: string | undefined
}) {
  const initial = brand.charAt(0).toUpperCase() || "?"
  return (
    <span
      className={cn(
        "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-md bg-card text-[10px] font-medium text-muted-foreground ring-1 ring-border/80",
        className
      )}
    >
      {initial}
    </span>
  )
}
